import React from "react";
import { Button, Col, Form, message, Modal, Row } from "antd";

import { formatToMomentObject, formatDateDisplay } from "utils/date";

import FormDatePicker from "components/FormDatePicker/FormDatePicker";
import FormInput from "components/FormInput/FormInput";
import Locale from "react-intl-universal";

const { useForm } = Form;
const { confirm } = Modal;

const AddFutureReviewModal = ({
  visible,
  onOk,
  onCancel,
  onRemove,
  defaultValues,
}) => {
  const [form] = useForm();

  const getInitialValues = () => {
    if (defaultValues) {
      return {
        ...defaultValues,
        nextReviewDate: formatToMomentObject(defaultValues.nextReviewDate),
      };
    }
  };

  const handleOnOkButtonClick = async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();

      const formattedValues = {
        ...values,
        nextReviewDate: formatDateDisplay(values.nextReviewDate),
      };

      onOk(formattedValues);
    } catch (error) {
      error.errorFields.forEach((field) => message.error(field.errors[0]));
    }
  };

  const handleOnRemoveButtonClick = () => {
    confirm({
      title: Locale.get("futureArea.confirmRemove"),
      okText: Locale.get("futureArea.yes"),
      onOk() {
        onRemove();
      },
      onClose() {},
    });
  };

  const footer = defaultValues
    ? [
        <Button key="remove" onClick={handleOnRemoveButtonClick}>
          {Locale.get("futureArea.remove")}
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          {Locale.get("futureArea.save")}
        </Button>,
      ]
    : [
        <Button key="cancel" onClick={onCancel}>
          {Locale.get("futureArea.cancel")}
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          {Locale.get("futureArea.addReview")}
        </Button>,
      ];

  return (
    <Modal
      title={Locale.get("futureArea.futureReviewDetail")}
      visible={visible}
      onOk={handleOnOkButtonClick}
      onCancel={onCancel}
      footer={footer}
    >
      <Form form={form} initialValues={getInitialValues()}>
        <Row gutter={[16, 4]}>
          <Col span={24}>
            <FormInput
              label={Locale.get("futureArea.areaFutureReview")}
              name="area"
              extraProps={{
                onPressEnter: handleOnOkButtonClick,
              }}
            />
          </Col>
          <Col span={24}>
            <FormInput
              label={Locale.get("futureArea.problemToSolve")}
              name="problem"
              type="textArea"
              extraProps={{
                onPressEnter: handleOnOkButtonClick,
              }}
            />
          </Col>
          <Col span={24}>
            <FormDatePicker
              label={Locale.get("futureArea.nextReviewDate")}
              name="nextReviewDate"
            />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddFutureReviewModal;
